import { gql } from "@apollo/client";

export const EXTRACT_BUDGET = gql`
  query ExtractBudget($cId: ID!, $pId: ID!, $file: String!, $file_extension: String, $file_name: String, $sheet_name: String) {
    extractBudget(cId: $cId, pId: $pId, file: $file, file_extension: $file_extension, file_name: $file_name, sheet_name: $sheet_name) {
      project_uuid
      project_name
      status
      description_column
      cost_column
      budget_items {
        row
        description
        cost
      }
      total_items
      error
    }
  }
`;
